import { create } from 'zustand';
import api from '@/lib/api';

/**
 * Branding store - loads white-label settings and applies CSS variables.
 * This makes tenant branding (primary color, sidebar, app name, logo) live.
 */
const DEFAULT_BRANDING = {
  primary_color: '#f97316',
  accent_color: '#d97706',
  sidebar_color: '#faf9f7',
  logo_url: '',
  app_name: 'Smarto',
  tagline: 'Business Management Platform',
  login_bg_color: '#ea580c',
};

function hexToHSL(hex) {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0, l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
      case g: h = ((b - r) / d + 2) / 6; break;
      case b: h = ((r - g) / d + 4) / 6; break;
      default: break;
    }
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

function applyBrandingCSS(branding) {
  const root = document.documentElement;
  if (branding.primary_color) {
    const hsl = hexToHSL(branding.primary_color);
    root.style.setProperty('--primary', hsl);
    root.style.setProperty('--ring', hsl);
  }
  if (branding.accent_color) {
    root.style.setProperty('--accent', hexToHSL(branding.accent_color));
  }
}

export const useBrandingStore = create((set, get) => ({
  branding: DEFAULT_BRANDING,
  loaded: false,

  loadBranding: async () => {
    try {
      const res = await api.get('/branding');
      const data = { ...DEFAULT_BRANDING, ...res.data };
      set({ branding: data, loaded: true });
      applyBrandingCSS(data);
    } catch {
      set({ loaded: true });
    }
  },

  updateBranding: (data) => {
    const merged = { ...get().branding, ...data };
    set({ branding: merged });
    applyBrandingCSS(merged);
  },
}));
